import { Component, OnInit, Input } from '@angular/core';
import { WinService } from 'src/app/services/win.service';
import { ProductService } from 'src/app/services/api/product.service';

@Component({
  selector: 'app-glossy-icon',
  templateUrl: './glossy-icon.component.html',
  styleUrls: ['./glossy-icon.component.scss']
})
export class GlossyIconComponent implements OnInit {

	@Input() product: any = null;
	@Input() bg: any = null;

	constructor(
		public productService: ProductService,
		public winService: WinService
	) { }

	ngOnInit() {
	}

}
